import styled, { css } from 'styled-components';

import { Dropdown } from '../../components/Toolkit/Dropdown/Dropdown';
import { InputButton } from '../../components/Toolkit/InputButton/InputButton';

import { theme } from '../../helpers/Theme';
import type {
  ContainerStyleProps,
  SecondarySelectContainerStyleProps,
} from '../../features/location/Location.typed';

const Container = styled.div<ContainerStyleProps>`
  display: flex;
  width: 100%;
  flex-direction: ${({ stackVertically }) =>
    stackVertically ? 'column' : 'row'};
  ${({ verticalGap }) => verticalGap && `gap: ${theme.spacing[verticalGap]};`}
`;

const DropdownStyles = css`
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
`;

const SDropdown = styled(Dropdown)<ContainerStyleProps>`
  width: 100%;
`;

const InputButtonWithSecondarySelect = styled.div<ContainerStyleProps>`
  display: flex;
  flex-direction: ${({ stackVertically }) =>
    stackVertically ? 'column' : 'row'};
  ${({ verticalGap }) => verticalGap && `gap: ${theme.spacing[verticalGap]};`}
`;

const SInputButton = styled(InputButton)<ContainerStyleProps>`
  border-top-right-radius: ${({ stackVertically }) =>
    stackVertically ? theme.borderRadius.default : 0};
  border-bottom-right-radius: ${({ stackVertically }) =>
    stackVertically ? theme.borderRadius.default : 0};
`;

const SecondarySelectContainer = styled.div<SecondarySelectContainerStyleProps>`
  display: flex;
  min-width: ${({ secondarySelectWidth }) => `${secondarySelectWidth}`};
`;

export {
  Container,
  DropdownStyles,
  SDropdown,
  InputButtonWithSecondarySelect,
  SInputButton,
  SecondarySelectContainer,
};
